import { NOTIFICATIONS_REQUEST, RESET_NOTIFICATIONS } from "../action.types";
import initialState from "../initial.state";

export default function(state = initialState.notifications, action) {
  switch (action.type) {
    case NOTIFICATIONS_REQUEST:
      return action.payload;
    case RESET_NOTIFICATIONS:
      return initialState.notifications;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/notification/notifications.reducer.js